var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.$slots.default)?_c('div',{staticClass:"block-aside",attrs:{"id":_vm.id}},[_c('div',{staticClass:"block-aside-content"},[_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }